<template>
    <div>
        <h2>Методы оплаты</h2>
        <div v-for="paymentMethod in methods">
            <form
                    autocomplete="off"
                    novalidate
                    method="post"
                    style="max-width: 500px"
            >
                <q-field>
                    <h-input
                            stack-label="Метод оплаты"
                            :disable="true"
                            v-model="paymentMethod.method"
                    />
                </q-field>

                <q-field>
                    <h-input
                            stack-label="Номер карты"
                            :disable="true"
                            v-model="paymentMethod.card_pan"
                    />
                </q-field>

                <q-field>
                    <h-input
                            stack-label="Владелец карты"
                            :disable="true"
                            v-model="paymentMethod.client_name"
                    />
                </q-field>

                <q-field>
                    <q-select
                            @input="update(paymentMethod.id)"
                            stack-label="Автооплата"
                            v-model="paymentMethod.enabled"
                            :options="getAutoPayment"
                    />
                </q-field>
            </form>

            <br>
            <br>
        </div>
    </div>
</template>

<script>
import columnsValues from '@/HTable/columnsValues'
import HInput from '@/HInput'
import { QField, QInput, QSelect } from 'quasar'
import api from 'mixins/api'

export default {
  name: 'ProjectPaymentMethods',

  props: {
    paymentMethods: {
      type: Array,
      required: true,
    },
  },

  components: {
    QField,
    QInput,
    QSelect,
    HInput,
  },

  mixins: [
    api,
  ],

  data () {
    return {
      methods: [],
    }
  },

  methods: {
    update (id) {
      let paymentMethod = this.methods.find((paymentMethod) => paymentMethod.id === id)

      this.api.put(`/projects/${ this.$route.params.id }/payment-method-type/${ id }`, {
        enabled: paymentMethod.enabled,
      }).then(response => {
        this.$store.commit('project/setPaymentMethods', response.data)
        this.$q.notify({ message: 'Сохранено', type: 'positive' })
      }).catch(error => {
        this.$q.notify({ message: error, type: 'positive' })
      })
    },
  },

  computed: {
    getAutoPayment () {
      return columnsValues.autoPayment
    },
  },

  mounted () {
    this.methods = [...this.paymentMethods]
  },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ProjectPaymentMethods/ProjectPaymentMethods.vue